import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import { NO_INTERNET_CONNECTION } from 'constants/dialogs';
import { closeDialog } from 'store/actions';
import NoConnectIcon from './noConnectIcon';
import Dialog from 'components/dialog';

const NoInternetConnection = ({ isOpen, t }) => {
  const dispatch = useDispatch();

  const handleCloseDialog = () => {
    dispatch(closeDialog(NO_INTERNET_CONNECTION));
  };

  const content = (
    <>
      <h4>{t('dialogNoInternetConnectionContent1')}</h4>
      {t('dialogNoInternetConnectionContent2')}
    </>
  );

  return (
    <Dialog
      okButtonText={t('dialogNoInternetConnectionOkButtonText')}
      content={content}
      disableCancelButton
      isOpen={isOpen}
      icon={<NoConnectIcon />}
      onCancel={handleCloseDialog}
      type={NO_INTERNET_CONNECTION}
      onConfirm={handleCloseDialog}
    />
  );
};

NoInternetConnection.propTypes = {
  isOpen: PropTypes.bool.isRequired,
};

export default NoInternetConnection;
